module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./DailyView.js"));
	}, "DailyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DailyView!./src/pages/Learn/Daily/DailyView.js
// module id = 1228
// module chunks = 431